import React from 'react'
import styled from 'styled-components/macro'
import { Helmet } from 'react-helmet'
import { MEDIA } from '../utils/styles'

import Layout from '../components/Layout'
import DocumentHead from '../components/DocumentHead'
import NotFoundCopyText from '../components/notFound/NotFoundCopyText'
// import NotFoundTodaysTopStories from '../components/notFound/NotFoundTodaysTopStories'

import NOTFOUND_IMG from '../statics/images/404-not-found.jpg'

import AdSlot, { ScAdSlotLeader } from 'wsc/components/AdSlot'
import AdFooter from 'wsc/components/AdFooter'

const ScWrapper = styled.div`
  ${MEDIA.DESKTOP`margin: 50px 0;`}
  ${MEDIA.TABLET`margin: 40px 0;`}
  ${MEDIA.MOBILE`margin: 30px 0;`}
`

const ScNotFoundImage = styled.img`
  display: block;
  margin: 0 auto 1.875rem;
  width: auto;
  height: 100%;
  ${MEDIA.MOBILE`width: 100%; max-width: 23rem; `}
  ${MEDIA.TABLET`max-height: 15.875rem;`}
  ${MEDIA.DESKTOP`max-height: 18.875rem;`}
`
const ScNotFoundCopyTextWrapper = styled.div`
  margin-bottom: 2.5rem;
  ${MEDIA.TABLET`margin-bottom: 3.75rem;`}
  ${MEDIA.DESKTOP`margin-bottom: 4.375rem;`}
`

/*----------------------------------------------------------------------------------
 *  RENDER PHASE
 *---------------------------------------------------------------------------------*/

const NotFound = props => {
  return (
    <Layout>
      <DocumentHead title="Not Found" />

      <Helmet>
        <meta name="robots" content="noindex"></meta>
      </Helmet>

      <ScAdSlotLeader>
        <AdSlot type="leaderboard_atf" />
      </ScAdSlotLeader>

      <ScWrapper>
        <ScNotFoundImage src={NOTFOUND_IMG} />
        <ScNotFoundCopyTextWrapper>
          <NotFoundCopyText />
        </ScNotFoundCopyTextWrapper>
        {/* <NotFoundTodaysTopStories /> */}
      </ScWrapper>

      <AdFooter />
    </Layout>
  )
}

NotFound.propTypes = {}
NotFound.defaultProps = {}

export default NotFound
